<script setup lang="ts">

import type { IHealthMonitorFeature } from '@domain/CarePlan';

type Props = { feature: IHealthMonitorFeature }; 
const { feature } = defineProps<Props>();
const iconName = feature.hasIssueDetected ? 'exclamation'
               : feature.isInstalled == false ? 'disconnected'
               : 'heartbeat';

</script>

<template>

    <div class="w-full h-[175px] 3xl:h-[200px] flex flex-col items-center justify-center">

        <img src="@/assets/images/health-monitor/carbucks-obd-dark.png" class="absolute h-2/3" />

        <div class="absolute flex flex-col items-center bottom-0"
             :class="{ 
                'text-emerald-300/50': feature.isInstalled && feature.isPaired && feature.hasIssueDetected == false,
                'text-gray-500': feature.isInstalled == false,
                'text-amber-600': feature.isInstalled && feature.isPaired == false && feature.hasIssueDetected == false,
                '!text-rose-600': feature.hasIssueDetected
             }">
            <div class="rounded-full aspect-square p-1 z-10 mb-1
                        flex items-center justify-center bg-current">
                <Icon :name="iconName" class="text-2xl text-white"/>
            </div>
            <div class="rounded-full uppercase pt-1.5 pb-2 px-4 lg:px-6 -mt-2
                        text-current text-sm font-bold">
                <span v-if="feature.hasIssueDetected">Issue Detected</span>
                <span v-else-if="feature.isInstalled == false">Not Installed</span>
                <span v-else-if="feature.isPaired == false">Installed - Not Paired</span>
                <span v-else>Active</span>
            </div>
        </div>

    </div>

</template>